import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { timeout } from 'rxjs';
import { BrowserModule } from '@angular/platform-browser';
import { BulkProgressToastComponent } from './shared/bulk-progress-toast/bulk-progress-toast.component';

import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  NgbModule,
  NgbTooltipModule,
  NgbPopoverModule,
  NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { PagesModule } from './pages/pages.module';
import { LayoutsModule } from './layouts/layouts.module';
import { ExtrapagesModule } from './extrapages/extrapages.module';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { CustomSpecInterceptor } from './core/interceptors/custom-spec.interceptor';
import { SharedModule } from './shared/shared.module';
import { SpinnerInterceptor } from './core/interceptors/spinner.Interceptor';
import { AppContextService } from './core/providers/context/AppContextService ';
import { ConnexionInterceptor } from './core/interceptors/connexion.interceptor';

registerLocaleData(localeFr);

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

function initializeApp(appContextService: AppContextService) {
  return () => {
    const isUserLoggedIn = localStorage.getItem('authToken');
    // const isAdmin = localStorage.getItem('isAdmin');
    if (isUserLoggedIn) {
      return appContextService.loadContext().pipe(timeout(15000)).toPromise().catch(error => {
        if (error?.status === 401 || !localStorage.getItem('authToken')) {
          for (const key of ['authToken', 'refreshToken', 'currentUser', 'firmContext']) { localStorage.removeItem(key); }
        } else {
          appContextService.initializationFailed = true;
        }
      });
    }
    return Promise.resolve();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    PagesModule,
    LayoutsModule,
    BrowserAnimationsModule,
    NgbModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbNavModule,
    ExtrapagesModule,
    SharedModule,
    BulkProgressToastComponent,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr' },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ConnexionInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomSpecInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppContextService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
